import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function CampaignsPagination({
  t, total = 0, currentPage = 1, lastPage = 1, pageSize, onPageChange, onPageSizeChange, selectedCount = 0
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-2 py-3">
      <span className="text-sm text-secondary">
        {t('promo.listing.table.selected', { count: selectedCount, total })}
      </span>

      <div className="flex items-center gap-4">
        <select
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          className="border border-border-lines rounded-lg px-2 py-1 text-sm text-dark-blue"
        >
          {[10, 20, 50].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>

        <span className="text-sm text-secondary whitespace-nowrap">
          {t('promo.listing.table.page_of', { page: currentPage, total: lastPage })}
        </span>

        <div className="flex items-center gap-1">
          <button type="button" onClick={() => onPageChange(1)} disabled={currentPage === 1} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleDoubleLeft size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleLeft size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= lastPage} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleRight size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(lastPage)} disabled={currentPage >= lastPage} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleDoubleRight size={16} className="text-secondary" />
          </button>
        </div>
      </div>
    </div>
  )
})
